export const NewsSliceConstants = {
  GetNews: 'getNews',
  GetAllNews: 'getAllNews',
  GetAllLatestNews: 'getAllLatestNews',
  GetNewsDate: 'getNewsDate',
};
